/** WarehouseReadinessRoute — pass-through; WarehouseReadiness owns its masthead. */
import WarehouseReadiness from "./WarehouseReadiness";

export default function WarehouseReadinessRoute() {
  return <WarehouseReadiness />;
}
